import fetch from '../lib/fetch';
import config from 'config';
import { reportError } from '../app';

const actionPrefix = 'chat/file-upload/';

export const START = `${actionPrefix}start`;
export const start = () => ({ type: START });

export const SELECT_FILES = `${actionPrefix}select-files`;
export const selectFiles = files => ({ type: SELECT_FILES, files });

export const UPLOAD_START = `${actionPrefix}upload/start`;
export const UPLOAD_ERROR = `${actionPrefix}upload/error`;
export const UPLOAD_PROGRESS = `${actionPrefix}upload/progress`;
export const UPLOAD_FILE_COMPLETED = `${actionPrefix}upload/file-completed`;
export const UPLOAD = `${actionPrefix}upload`;
function _arrayBufferToBase64( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}
export const startUpload = (sendToAgent, caseNumber, files, token, embedded) => dispatch => {
  var i = 0, failureDetected = false;

  function nextFile() {
    let file = files[i];

    if (!file) {
      sendToAgent(files);
      dispatch({ type: UPLOAD, files });
      return;
    }

    let xhr = new XMLHttpRequest(),
        reader = new FileReader(),
        fileNameParts = file.name.split('.');

    xhr.upload.addEventListener('progress', e => dispatch({
      type: UPLOAD_PROGRESS,
      index: i,
      percentaje: e.lengthComputable ? Math.round((e.loaded * 100) / e.total) : false
    }));

    xhr.addEventListener('load', e => {
      if (!failureDetected) {
        if (e.target.status !== 200) {
          failureDetected = true;
          dispatch({ type: UPLOAD_ERROR, error: 'Error uploading file' });
        } else {
          let response = JSON.parse(e.target.responseText);
          files[i].guid = response.guid;
          files[i].fileType = response.type;
          dispatch({
            type: UPLOAD_FILE_COMPLETED,
            index: i
          });
          i += 1;
          nextFile();
        }
      }
    });
    xhr.onerror = () => {
      failureDetected = true;
      dispatch({ type: UPLOAD_ERROR, error: 'Error uploading file' });
    };
    xhr.open('POST', `${embedded ? config.embeddedApiRootUrl : config.apiRootUrl}/fileupload/${caseNumber}/${encodeURIComponent(fileNameParts[0])}/${encodeURIComponent(fileNameParts[1])}`);
    xhr.setRequestHeader('Authorization', 'Bearer ' + token);
    xhr.overrideMimeType('text/plain');
    reader.onerror = () => {
      failureDetected = true;
      dispatch({ type: UPLOAD_ERROR, error: 'Error reading file' });
    };
    reader.onload = e => xhr.send(_arrayBufferToBase64(e.target.result));
    reader.readAsArrayBuffer(file);
  }

  nextFile();

  return dispatch({ type: UPLOAD_START, files });
};
export const uploadEnded = () => ({ type: UPLOAD });
export const uploadError = error => ({ type: UPLOAD_ERROR, error });

export const MINIMIZE = `${actionPrefix}minimize`;
export const minimize = () => ({ type:  MINIMIZE });

export const RECEIVE_IMAGES = `${actionPrefix}receive-images`;
export const RECEIVE_IMAGES_ERROR = `${actionPrefix}receive-images/error`;
export const receiveImages = (caseNumber, alreadyReceivedImages) => dispatch => fetch(
  `fileUpload/retrieve/${caseNumber}`, { method: 'POST', body: alreadyReceivedImages }
).then(images => dispatch({ type: RECEIVE_IMAGES, images }))
.catch(error => dispatch({ type: RECEIVE_IMAGES_ERROR, error }));

export const IMAGE_VIEW = `${actionPrefix}image-view`;
export const IMAGE_VIEW_CANCEL = `${actionPrefix}image-view/cancel`;
export const cancelImageView = () => ({ type: IMAGE_VIEW_CANCEL });
export const viewImage = image => ({ type: IMAGE_VIEW, image });

export const UPLOAD_SINGLE = `${actionPrefix}upload/single`;
export const UPLOAD_SINGLE_REQUEST = `${UPLOAD_SINGLE}/request`;
export const UPLOAD_SINGLE_FAIL = `${UPLOAD_SINGLE}/fail`;
export const singleUpload = (caseNumber, fileName, extension, base64EncodedFile) => async dispatch => {
  dispatch({ type: UPLOAD_SINGLE_REQUEST });

  try {
    const result = await fetch(`fileupload/${caseNumber}/${fileName}/${extension}/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'text/plain'
      },
      body: base64EncodedFile
    });

    return dispatch({ type: UPLOAD_SINGLE, fileType: result.type, guid: result.guid });
  } catch (error) {
    error.additionalInformation = {
      caseNumber,
      fileName,
      extension,
      base64ImageLength: base64EncodedFile.length
    };
    reportError(error);
    return dispatch({ type: UPLOAD_SINGLE_FAIL, error });
  }
};


// WEBPACK FOOTER //
// ./actions/chat/fileUpload.js